import React from 'react';
import { Reveal } from './Reveal';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const testimonials: Testimonial[] = [{
  initials: 'JK',
  quote: 'I had Reiki training but no idea how to structure a session or talk to clients professionally. Volume 5 literally changed my business. I went from offering free sessions to charging $150 per client. The protocols and scripts are gold.',
  name: 'Jennifer K.',
  role: 'New York, USA · Energy Practitioner'
}, {
  initials: 'MR',
  quote: 'The Emotional Blockage Map bonus is incredible. My clients feel so seen when I can connect their physical pain to emotional roots. They book more sessions because the work feels deeper. This system transformed how I practice.',
  name: 'Michael R.',
  role: 'London, UK · Holistic Coach'
}, {
  initials: 'SL',
  quote: 'As someone wanting to become a Reiki Master, Volume 3 gave me the confidence to start training others. The attunement protocols and teaching frameworks are professional-grade. Worth ten times the price.',
  name: 'Sofia L.',
  role: 'Barcelona, Spain · Spiritual Teacher'
}];
export function TestimonialStrip() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-224" data-mp="208bfxbh925zj">
      <div className="mx-auto max-w-6xl" data-id="element-225" data-mp="1vficcqxip3p1">
        <Reveal className="text-center" data-id="element-226" data-mp="1vefo6qrkxfct">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-227" data-mp="297588pnjsa7a">
            ⭐ What Practitioners Are <span className="text-sage" data-id="element-228" data-mp="255tqt7etuva6">Saying</span>
          </h2>
          <p className="mt-4 text-slate" data-id="element-229" data-mp="255k1lm1lws5j">
            People who finally have the system, structure, and confidence to work professionally.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-230" data-mp="2e7jk6is9s4al">
          {testimonials.map((item, index) => <Reveal key={item.initials} delay={index * 0.05} className="h-full" data-id="element-231" data-mp="osd2kvf1gxsi" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-8 shadow-premium" data-id="element-232" data-mp="jta8u74iedzu">
                <div className="text-amber" aria-label="5 out of 5 stars" data-id="element-233" data-mp="2jw1jd3l53gwi">
                  ★★★★★
                </div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-234" data-mp="2ovxesefru00g">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-235" data-mp="2xurjyt763ypm">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-236" data-mp="32tm17qphlf7m">
                    {item.initials}
                  </span>
                  <span data-id="element-237" data-mp="37qcg4apk24rg">
                    <span className="block font-bold text-navy" data-id="element-238" data-mp="3civtp7o8szw9">{item.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-239" data-mp="3gkzg2rcg9owb">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}